import {contacts} from './crmservices/contacts';
import {httpUtil} from './crmservices/httpUtil';
import { rewards } from './crmservices/rewards';
import { config } from './crmservices/config';
import { account } from './crmservices/account';
import { communications } from './crmservices/communications';
import { orders } from './crmservices/orders';
import { products } from './crmservices/products';
import { organisations } from './crmservices/organisations';
import { jcccards } from './crmservices/jcccardhash';
import { paymentgateway } from './crmservices/paymentgateway';
import { wifi } from './crmservices/wifi';
import { cignalservices } from './crmservices/cignalservices';
import { printout } from './crmservices/printout';
import { aynaottservices } from './crmservices/aynaottservices';
import { etvservices } from './crmservices/etvservices';
export default {
  contacts: contacts,
  rewards: rewards,
  config: config,
  account: account,
  communications: communications,
  orders: orders,
  products: products,
  organisations:organisations,
  jcccards:jcccards,
  setupChannel: httpUtil.setupChannel,
  getSession : httpUtil.getSession,
  startSession: httpUtil.startSession,
  cleanSession: httpUtil.startSession,
  paymentgateway: paymentgateway,
  wifi: wifi,
  cignalservices:cignalservices,
  printout:printout,
  etvservices:etvservices,
  aynaottservices:aynaottservices
}